
export const ACTION_UPDATE = 'block/ACTION_UPDATE';
export const ACTION_LOAD_BLOCK = 'block/ACTION_LOAD_BLOCK';
